"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseLogger = exports.responseErrorLogger = exports.requestLogger = void 0;
var _webautoAuthCore = require("@tier4/webauto-auth-core");
const requestLogger = logger => {
  return async config => {
    logger.info({
      data: JSON.stringify(filterCredentials(config.data)),
      method: config.method,
      url: config.url
    });
    return config;
  };
};
exports.requestLogger = requestLogger;
const logResponse = (logger, res) => {
  var _res$config;
  if (!(0, _webautoAuthCore.isNonNullObject)(res)) {
    return;
  }
  const req = res.request;
  const message = {
    data: JSON.stringify(filterCredentials(res.data)),
    method: (0, _webautoAuthCore.isNonNullObject)(req) && (0, _webautoAuthCore.hasKey)(req, "method") ? req.method : "",
    url: ((_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) ?? "",
    status: res.status
  };
  if (res.status < 400) {
    logger.info(message);
  } else if (res.status >= 400) {
    logger.warn(message);
  } else {
    logger.error(message);
  }
};
const responseLogger = logger => {
  return res => {
    logResponse(logger, res);
    return Promise.resolve(res);
  };
};
exports.responseLogger = responseLogger;
const responseErrorLogger = logger => {
  return error => {
    const res = error.response;
    logResponse(logger, res);
    return Promise.reject(error);
  };
};
exports.responseErrorLogger = responseErrorLogger;
const filterCredentials = data => {
  if (!data) {
    return data;
  }
  if (typeof data === "string" && isJsonString(data)) {
    return (0, _webautoAuthCore.filterCredentialsFromObject)(JSON.parse(data));
  }
  if (typeof data === "object") {
    return (0, _webautoAuthCore.filterCredentialsFromObject)(data);
  }
  return data;
};
const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
//# sourceMappingURL=logger.js.map